interface DefaultV3Shape {
  name: string
  type: 'image' | 'backgroundColor'
}
export const defaultV3: DefaultV3Shape = { name: 'v3-holidays-2024-4', type: 'image' } as const
export const v3WithImageBg = 'mask-v3'
